import { FC } from 'react';

import PlaceIcon from '@mui/icons-material/Place';
import ToolCard from 'components/ToolCard';
import Button from '@mui/material/Button';

const PlacesCard: FC = () => (
  <ToolCard
    icon={<PlaceIcon fontSize="large" />}
    title="Vietos"
    description="Kelionės krypčių redagavimas"
    action={
      <Button href="countries" startIcon={<PlaceIcon />} size="small">
        Redaguoti
      </Button>
    }
  />
);

export default PlacesCard;
